/**
 * Client wrappers for /api/dashboard/* endpoints. Thin GETs — the analytics
 * server compute fresh on every request, no caching here either.
 */
import { apiFetch } from "./api";

export interface DashboardUtilisationRow {
  personId: number;
  name: string;
  wl: number;
  utilisation: Record<string, number>;
}

export interface DashboardProjectCard {
  id: number;
  name: string;
  code: string;
  status: "active" | "planned" | "archived";
  budget: number;
  pmId: number | null;
  teamCount: number;
  unassignedCount: number;
}

export interface DashboardFinanceSummary {
  revenue: number;
  cost: number;
  margin: number;
  marginPct: number;
}

async function getJsonArray<T>(path: string): Promise<T[]> {
  const res = await apiFetch(path);
  if (!res.ok) throw new Error(`${path}: ${res.status}`);
  const body: unknown = await res.json();
  return Array.isArray(body) ? (body as T[]) : [];
}

async function getJsonObject<T>(path: string): Promise<T> {
  const res = await apiFetch(path);
  if (!res.ok) throw new Error(`${path}: ${res.status}`);
  return (await res.json()) as T;
}

export const getDashboardUtilisation = (): Promise<DashboardUtilisationRow[]> =>
  getJsonArray<DashboardUtilisationRow>("/api/dashboard/utilisation");

export const getDashboardProjectsSummary = (): Promise<DashboardProjectCard[]> =>
  getJsonArray<DashboardProjectCard>("/api/dashboard/projects-summary");

export const getDashboardFinanceSummary = (): Promise<DashboardFinanceSummary> =>
  getJsonObject<DashboardFinanceSummary>("/api/dashboard/finance-summary");

export const getDashboardActiveProjectIds = (): Promise<number[]> =>
  getJsonArray<number>("/api/dashboard/active-project-ids");

export const getDashboardOpenablePersonIds = (): Promise<number[]> =>
  getJsonArray<number>("/api/dashboard/openable-person-ids");
